import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import {throwError as observableThrowError,  Observable, of as observableOf } from 'rxjs';
import { catchError, map } from "rxjs/operators";
import { ICategories } from '../interfaces/categories';
import { ISubcategories } from '../interfaces/subcategories';

@Injectable({
  providedIn: 'root'
})
export class SubcategoryService {

  constructor(private _apiService: ApiService) {
  }

  getSubcategoriesFrom(idsubcategoria: number) : Observable<ISubcategories>  {
    return this._apiService.doGET('store/subcategory/'+idsubcategoria)
    .pipe(catchError(err => {
      return observableOf([])
    }))
  }
}
